import React, { Component } from 'react'
import SimpleTabs from './components/OrderTabPanel';

class OrderTab extends Component {
    render() {
        return (
            <div>
              <SimpleTabs />
            </div>
        )
    }
}
  
export default OrderTab
  